module.exports = __webpack_public_path__ + "img/logo.584dae47.png";